module.exports = __webpack_public_path__ + "img/n2.29d43f27.png";